import { InjectionToken } from '@angular/core';
import { CommonsUtilService } from 'ib-web-commons/app/core/utils/ib-commons-utils-service';
import { upgradeAJSServiceProvider } from 'ib-web-commons/utils'; 
export const AJSGiftCardsCommonsUtilService = new InjectionToken('CommonsUtilService');
export const AJSGiftCardsCommonsUtilServiceProvider = upgradeAJSServiceProvider('CommonsUtilService', AJSGiftCardsCommonsUtilService);
export interface GiftCardsCommonsUtilServiceType extends CommonsUtilService {
    setTitlePage(title)
    getUserTypeByToken()
    keydownInput(dataIn)
    resetFields(dataIn)
}
